import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';

import { ConfigurationReaderBase } from './ConfigurationReader';
import { OAuthService } from 'angular-oauth2-oidc';
import { Authentication, AuthenticationBase } from './Authentication';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private oauthService: OAuthService, private authenticationService: AuthenticationBase,
                private configuration:ConfigurationReaderBase, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.checkLogin(state.url);
    }

    checkLogin(url: string): boolean {
        
        if (this.oauthService.hasValidAccessToken()) { return true; }

        // Getting Parameters passes for redirect
        // if (url.startsWith("/Home?id=")) {
        //     let cleanURI = decodeURIComponent(url);
        //     cleanURI = cleanURI.replace("/Home?id=", "");

        //     let jParam = cleanURI.split("&");
            
        //     //Look for specific parameter if applies
        //     //ex:
        //     /*
        //     if (jParam[0].startsWith("UserVerification")) {
        //         jParam = jParam[0].split("_");
        //         this.router.navigate(['/User/Verification', jParam[1]]);
        //         return false;
        //     }
        //     */
        // }
        //Response from IDP comming back to this route
        else if(url.startsWith(this.configuration.Configuration.landingURL) && url.indexOf('#id_token') > 0 ){            
            return true;
        }

        // Navigate to the login page with extras
        this.router.navigate(['/Home']);        
        return false;
    }
}




// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/Shared/service/AuthGuard.ts